import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const EmailLine24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.8499 6.00003C22.8499 4.42601 21.5739 3.15002 19.9999 3.15002H3.9999C2.42589 3.15002 1.1499 4.42601 1.1499 6.00002L1.1499 18C1.1499 19.574 2.42589 20.85 3.9999 20.85H19.9999C21.5739 20.85 22.8499 19.574 22.8499 18L22.8499 6.00003ZM19.9999 4.85003C20.635 4.85003 21.1499 5.3649 21.1499 6.00003V6.55745L13.2328 12.0994C12.4925 12.6176 11.5072 12.6176 10.7669 12.0994L2.8499 6.5575V6.00002C2.8499 5.3649 3.36478 4.85002 3.9999 4.85002L19.9999 4.85003ZM2.8499 8.63261L2.8499 18C2.8499 18.6352 3.36477 19.15 3.9999 19.15H19.9999C20.635 19.15 21.1499 18.6352 21.1499 18V8.63256L14.2077 13.4921C12.8821 14.42 11.1177 14.42 9.79204 13.4921L2.8499 8.63261Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
